import { h, Component } from "preact";
import { css } from "emotion";
import Image from "../../components/Image";

const charityImgWrapper = css`
  display: inline-block;
  margin-right: 12px;
  margin-bottom: 12px;
  &:nth-child(3) {
    margin-right: 0;
  }
  @media (max-width: 1000px) {
    &:nth-child(3) {
      margin-right: 12px;
    }
    &:nth-child(calc(100% / 82)) {
      margin-right: 0;
    }
  }
`;

const wrapper = css`
  width: 100%;
  background-color: #fff;
  box-shadow: 0 1px 10px 2px rgba(32, 7, 64, 0.13);
  padding: 24px 20px;
  border-radius: 4px;
`;

const imageStyling = css({
  width: 70,
  height: 70,
  border: "solid 1.2px #DEDEDE",
  borderRadius: 4
});

const ImageBlock = charity => {
  return (
    <a href={charity.charity.website} className={charityImgWrapper}>
      <Image
        src={charity.charity.logo.url}
        className={imageStyling}
        alt={`${charity.charity.name} Logo`}
      />
    </a>
  );
};

const OrganiserCharities = ({ charities, name }) => {
  if (charities && charities.length > 0) {
    return (
      <div className={wrapper}>
        <h3 style={{ textAlign: "left", fontWeight: 600 }}>
          <span style={{ textTransform: "capitalize" }}>{name}</span> is
          supporting
        </h3>
        <div style={{ textAlign: "left" }}>
          {charities.map(charity => {
            return <ImageBlock charity={charity} />;
          })}
        </div>
      </div>
    );
  }
};

export default OrganiserCharities;



// WEBPACK FOOTER //
// ./routes/organiser/OrganiserCharities.js